import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Safety from "../pages/safety/page";
import Products from "../pages/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/fr",
    element: <Home />,
  },
  {
    path: "/da",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/en/blog/:slug",
    element: <Article />,
  },
  {
    path: "/fr/blog/:slug",
    element: <Article />,
  },
  {
    path: "/da/blog/:slug",
    element: <Article />,
  },
  {
    path: "/de/blog/:slug",
    element: <Article />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/en/products",
    element: <Products />,
  },
  {
    path: "/fr/products",
    element: <Products />,
  },
  {
    path: "/da/products",
    element: <Products />,
  },
  {
    path: "/de/products",
    element: <Products />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/en/about",
    element: <About />,
  },
  {
    path: "/fr/about",
    element: <About />,
  },
  {
    path: "/da/about",
    element: <About />,
  },
  {
    path: "/de/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/en/contact",
    element: <Contact />,
  },
  {
    path: "/fr/contact",
    element: <Contact />,
  },
  {
    path: "/da/contact",
    element: <Contact />,
  },
  {
    path: "/de/contact",
    element: <Contact />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "/en/safety",
    element: <Safety />,
  },
  {
    path: "/fr/safety",
    element: <Safety />,
  },
  {
    path: "/da/safety",
    element: <Safety />,
  },
  {
    path: "/de/safety",
    element: <Safety />,
  },
  {
    path: "/blog",
    element: <Home />,
  },
  {
    path: "/en/blog",
    element: <Home />,
  },
  {
    path: "/fr/blog",
    element: <Home />,
  },
  {
    path: "/da/blog",
    element: <Home />,
  },
  {
    path: "/de/blog",
    element: <Home />,
  },
  {
    path: "/spreadsheet",
    element: <Home />,
  },
  {
    path: "/reviews",
    element: <Home />,
  },
  {
    path: "/shipping",
    element: <Home />,
  },
  {
    path: "/coupons",
    element: <Home />,
  },
  {
    path: "/warehouse",
    element: <Home />,
  },
  {
    path: "/qc",
    element: <Home />,
  },
  {
    path: "/guides",
    element: <Home />,
  },
  {
    path: "/categories",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;